import axios from '../../api/axios';
import React, { useState, useRef, useEffect } from 'react';
import { Search, ShoppingCart } from 'lucide-react';
import { printBill } from './billTemplate';
import CartItemRow from './cartItemRow';
import Navbar from '../navsidebar/navbar';
import Sidebar from '../navsidebar/sidebar';
import { RiEraserFill } from "react-icons/ri";
import './dashboard.scss';
import { Select, MenuItem } from '@mui/material';

// API Endpoints Constants
const API_ENDPOINTS = {
  SAVE_TO_CART: '/retail/saveitems-to-cart',
  GET_ORDER_ITEMS: '/retail/order-items',
  HOLD_ORDER: '/retail/orders/hold',
  GET_HOLD_ORDERS: '/retail/getallholdsorder',
  UPDATE_HOLD_STATUS: '/retail/update-isactive',
  SETTLE_BILL: '/retail/orders/update-customer',
  GET_SERVICE_PROVIDERS: '/retail/service-providers',
  UPDATE_ITEM_QUANTITY: '/retail/update-quantity',
  UPDATE_ITEM_DISCOUNT: '/retail/update-discount',
  DELETE_ORDER_ITEM: '/retail/delete-Order-Item',
  ADD_ORDER_ITEM: '/retail/add-Order-item',
  GET_CONFIGURATION: '/retail/configuration',
  GET_ITEM_BY_BARCODE: '/retail/getitembybarcode',
  GET_SECTIONS: '/retail/sections',
  GET_CATEGORIES: '/retail/sections',
  GET_ITEMS_BY_CATEGORY: '/retail/items/category',
  GET_ALL_ITEMS: '/retail/getAllitems',
  CHECK_CUSTOMER_TYPE: '/retail/checkCustomerType'
};


function RetailDashboard() {


  const { businessEntityId: business_entity_id, userId } = JSON.parse(sessionStorage.getItem("userData"));

  // Restore business entity logic for type 'G' businesses
  const storedData = JSON.parse(sessionStorage.getItem("userData"));
  let finalBusinessEntityId;

  if (storedData.business_type == 'G') {
    finalBusinessEntityId = sessionStorage.getItem('configBizEntityId') || business_entity_id;
  } else {
    finalBusinessEntityId = business_entity_id;
    sessionStorage.setItem("configBizEntityId", business_entity_id);
  }


  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState('dineIn');
  const [showBillDetails, setShowBillDetails] = useState(false);
  const [sectionId, setSectionId] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [cart, setCart] = useState([]);
  const [savedItems, setSavedItems] = useState([]);
  const [discount, setDiscount] = useState("");
  const [enableSplitPayment, setEnableSplitPayment] = useState(false);
  const [splitAmounts, setSplitAmounts] = useState({ cash: null, upi: null, card: null });
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
  const [paymentAmount, setPaymentAmount] = useState("");
  const [customerInfo, setCustomerInfo] = useState({ name: '', phone: '', gstNo: '' });
  const [customerType, setCustomerType] = useState(null);

  const [serviceProviders, setServiceProviders] = useState([]);
  const [selectedServiceProvider, setSelectedServiceProvider] = useState('');

  const [globalDiscount, setGlobalDiscount] = useState({
    type: "fixed",
    value: 0
  });

  const [loadingfetch, setLoadingfetch] = useState(false);

  const [orderId, setOrderId] = useState(() =>
    sessionStorage.getItem("orderID")
  );

  const [sections, setSections] = useState([]);
  const [categories, setCategories] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState({
    sections: false,
    categories: false,
    items: false
  });
  const [error, setError] = useState({
    sections: null,
    categories: null,
    items: null
  });
  const [sectionbilling, setsectionbilling] = useState("");


  // Fetch configuration
  const fetchConfiguration = async () => {
    const result = await apiCall(`${API_ENDPOINTS.GET_CONFIGURATION}/${finalBusinessEntityId}`);

    if (result.success) {
      const config = result.data;
      setsectionbilling(config.section_billing_enabled);
    } else {
      console.error("Error fetching configuration:", result.error);
    }
  };

  // Fetch service providers
  const fetchServiceProviders = async () => {
    const result = await apiCall(`${API_ENDPOINTS.GET_SERVICE_PROVIDERS}/${finalBusinessEntityId}`);

    if (result.success) {
      setServiceProviders(result.data.data || []);
    } else {
      console.error("Error fetching service providers:", result.error);
      setServiceProviders([]);
    }
  };

  useEffect(() => {
    fetchConfiguration();
    fetchServiceProviders();
  }, [finalBusinessEntityId]);


  const addToCart = (item) => {
    console.log("adddtocart", item);

    const existingItem = cart.find(cartItem => cartItem.item_id === item.item_id);

    // Ensure unitPrice is a valid number
    const unitPrice = Number(item.item_price) || 0;

    // If the item already exists in the cart, use its existing quantity; otherwise, default to 1
    const quantity = existingItem ? existingItem.quantity : 1;

    // Ensure tax values are valid numbers
    const cgst = Number(item.item_cgst) || 0;
    const sgst = Number(item.item_sgst) || 0;
    const totaltax = (cgst + sgst) / 100;

    // Calculate taxable amount (Price includes GST)
    const taxableAmount = (unitPrice / (1 + totaltax)) * quantity;

    console.log(taxableAmount, totaltax, sgst, cgst);

    const newItem = {
      ...item,
      quantity: quantity,
      discount: Number(item.discount) || 0, // Ensure discount is a number
      taxable_amount: parseFloat(taxableAmount.toFixed(2)), // Convert back to number
      cgst: parseFloat(cgst.toFixed(2)),
      sgst: parseFloat(sgst.toFixed(2)),
      total_price: parseFloat((unitPrice * quantity).toFixed(2)) // Ensure total price updates based on quantity
    };

    if (existingItem) {
      setCart(cart.map(cartItem =>
        cartItem.item_id === item.item_id
          ? {
            ...cartItem,
            quantity: cartItem.quantity + 1,
            total_price: parseFloat(((cartItem.quantity + 1) * unitPrice).toFixed(2)) // Update total price
          }
          : cartItem
      ));
    } else {
      setCart([...cart, newItem]);
    }
  };


  useEffect(() => {
    // Reset cart when sectionId changes

    if (sectionbilling === 1) {
      setCart([]);
      setSavedItems([]);
      fetchOrderItems(orderId)
    }

  }, [sectionId]);


  // Fetch sections based on shop ID
  const fetchSections = async () => {
    setLoading(prev => ({ ...prev, sections: true }));
    try {
      const response = await axios.get(`retail/sections/${finalBusinessEntityId}`);
      const data = response.data;
      setSections(data);
      setSectionId(data[0]?.id);
      // If sections exist, automatically select the first one
      if (data.length > 0) setSelectedSection(data[0]);
    } catch (err) {
      setError(prev => ({ ...prev, sections: err.message }));
    } finally {
      setLoading(prev => ({ ...prev, sections: false }));
    }
  };

  const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 20 });
  // Fetch categories based on selected section
  const fetchCategories = async (sectionId) => {
    setLoading(prev => ({ ...prev, categories: true }));
    try {
      const response = await axios.get(`retail/sections/${sectionId}/categories`);
      const data = response.data;

      setCategories(data.categories || []);

      // Fix: Only set the selected category if we have categories
      if (data.categories && data.categories.length > 0) {
        setSelectedCategory(data.categories[0]);
      } else {
        setSelectedCategory(null);
      }

      setPagination({
        currentPage: data.currentPage,
        totalPages: data.totalPages,
      });
    } catch (err) {
      setError(prev => ({ ...prev, categories: err.message }));
      setSelectedCategory(null);  // Reset on error
    } finally {
      setLoading(prev => ({ ...prev, categories: false }));
    }
  };

  // Fetch items based on selected category
  const fetchItems = async (categoryId, page = 1, limit = 100) => {
    setLoading(prev => ({ ...prev, items: true }));
    try {
      const response = await axios.get(`retail/items/category/${categoryId}`, {
        params: { page, limit },
      });

      setMenuItems(response.data.items || []);
    } catch (err) {
      setError(prev => ({ ...prev, items: err.message }));
    } finally {
      setLoading(prev => ({ ...prev, items: false }));
    }
  };


  // Fix 2: Update the useEffect for fetching items
  useEffect(() => {
    if (selectedCategory && selectedCategory.category_id) {
      fetchItems(selectedCategory.category_id);
    }
  }, [selectedCategory]);


  // Initial load - fetch sections and default to "All" items
  useEffect(() => {
    fetchSections();
    // Load all items by default
    handleAllitem();
  }, []);

  // Fix 2: Update the useEffect for fetching items
  useEffect(() => {
    if (selectedCategory && selectedCategory.category_id) {
      fetchItems(selectedCategory.category_id);
    }
  }, [selectedCategory]);

  // When section changes, fetch categories and default to "All"
  useEffect(() => {
    if (selectedSection) {
      fetchCategories(selectedSection.id);
      // Default to "All" items instead of first category
      handleAllitem();
    }
  }, [selectedSection]);

  const updateQuantity = (itemId, change) => {
    setCart(prevCart =>
      prevCart.map(item => {
        if (item.item_id === itemId) {
          const newQuantity = item.quantity + change;

          if (newQuantity <= 0) {
            return null; // This item will be filtered out
          }

          const newTotalPrice = parseFloat((newQuantity * Number(item.item_price)).toFixed(2));

          const taxRate = parseFloat((item.cgst + item.sgst) / 100)

          const newTaxableAmount = parseFloat((newTotalPrice / (1 + taxRate)).toFixed(2));


          return {
            ...item,
            quantity: newQuantity,
            total_price: newTotalPrice,
            taxable_amount: newTaxableAmount,
          };
        }
        return item;
      }).filter(Boolean)
    );
  };


  const calculateTotal = (items, globalDiscount) => {
    console.log("Global Discount Details:", {
      type: globalDiscount?.type,
      value: globalDiscount?.value
    });

    console.log("wwww", items)


    if (!items || items.length === 0) {
      return {
        total_amount: "0.00",
        total_discount: "0.00",
        taxable_amount: "0.00",
        total_cgst: "0.00",
        total_sgst: "0.00",
        global_discount_amount: "0.00",
        grand_total: "0.00"
      };
    }

    const totalMRP = items.reduce((sum, item) =>
      sum + (parseFloat(item.unit_price) * parseFloat(item.quantity)), 0
    );

    // Calculate totals
    const totalAmount = items.reduce((sum, item) =>
      sum + ((parseFloat(item.total_price) || 0)), 0
    );


    const totalDiscount = items.reduce((sum, item) =>
      sum + ((parseFloat(item.discounted_price) || 0)), 0
    );
    console.log("hhh", totalDiscount)

    const CGST = items.reduce((sum, item) => sum + ((parseFloat(item.cgst) || 0)), 0);
    const SGST = items.reduce((sum, item) => sum + ((parseFloat(item.sgst) || 0)), 0);
    const totaltax = (CGST + SGST) / 100;

    // Grand total before global discount
    let grandTotalBeforeGST = totalAmount;
    // let taxableAmount = grandTotalBeforeGST > 0 ? grandTotalBeforeGST / (1 + totaltax) : 0;
    // let totalCGST = taxableAmount * (CGST / 100);
    // let totalSGST = taxableAmount * (SGST / 100);

    // console.log("787",totalCGST,totalSGST  )

    // Ensure globalDiscount has a valid structure
    const validGlobalDiscount = globalDiscount || { type: "fixed", value: 0 };

    // Apply global discount
    let globalDiscountAmount = 0;
    if (validGlobalDiscount.type === "percentage") {
      globalDiscountAmount = grandTotalBeforeGST * (validGlobalDiscount.value / 100);
    } else if (validGlobalDiscount.type === "fixed") {
      globalDiscountAmount = validGlobalDiscount.value;
    }

    // Ensure discount does not exceed grand total
    globalDiscountAmount = Math.min(globalDiscountAmount, grandTotalBeforeGST);

    // Final grand total after applying global discount
    let grandTotalAfterDiscount = grandTotalBeforeGST - globalDiscountAmount;


    let taxableAmount = grandTotalAfterDiscount > 0 ? grandTotalAfterDiscount / (1 + totaltax) : 0;
    let totalCGST = taxableAmount * (CGST / 100);
    let totalSGST = taxableAmount * (SGST / 100);

    return {
      total_amount: Number(totalAmount || 0),
      total_discount: Number(totalDiscount || 0),
      taxable_amount: Number(taxableAmount || 0),
      total_cgst: Number(totalCGST || 0),
      total_sgst: Number(totalSGST || 0),
      global_discount_amount: Number(globalDiscountAmount || 0),
      grand_total: Number(grandTotalAfterDiscount || 0),
      itemDiscounts: Number(totalDiscount || 0),
      totalMRP: Number(totalMRP || 0)
    };
  };

  // Settle bill functionality
  const handleSettleBill = async () => {
    if (!savedItems.order_id) {
      alert("No active order to settle");
      return;
    }

    // Calculate the total amount based on whether split payment is enabled or not
    const totalAmount = enableSplitPayment
      ? Object.values(splitAmounts).reduce((acc, amount) => acc + Number(amount), 0)
      : Number(paymentAmount);

    // Get grand total from the saved items and global discount
    const totalcalculation = calculateTotal(savedItems.items, globalDiscount);
    const grandTotal = totalcalculation.grand_total;

    // Check if the total payment amount is greater or equal to the grand total
    if (Math.floor(totalAmount) >= Math.floor(grandTotal)) {
      const refundAmount = totalAmount - grandTotal;

      // Prepare payment details
      let paymentMode = '';
      let viaCash = 0;
      let viaUpi = 0;
      let viaCard = 0;

      if (enableSplitPayment) {
        paymentMode = Object.keys(splitAmounts).filter(method => splitAmounts[method] !== null).join(', ');
        viaCash = splitAmounts.cash || 0;
        viaUpi = splitAmounts.upi || 0;
        viaCard = splitAmounts.card || 0;
      } else {
        paymentMode = selectedPaymentMethod;
        if (selectedPaymentMethod === 'cash') {
          viaCash = paymentAmount;
        } else if (selectedPaymentMethod === 'upi') {
          viaUpi = paymentAmount;
        } else if (selectedPaymentMethod === 'card') {
          viaCard = paymentAmount;
        }
      }

      const orderDetails = {
        order_id: savedItems.order_id,
        customer_name: customerInfo.name,
        gst_number: customerInfo.gstNo,
        customer_phone: customerInfo.phone,
        discount_type: globalDiscount.type,
        total_discount: totalcalculation.global_discount_amount,
        total_amount: grandTotal,
        total_cgst: totalcalculation.total_cgst,
        total_sgst: totalcalculation.total_sgst,
        taxable_amount: totalcalculation.taxable_amount,
        payment_mode: paymentMode,
        via_cash: viaCash,
        via_upi: viaUpi,
        via_card: viaCard,
        businessEntityId: finalBusinessEntityId,
        serviceProviderId: selectedServiceProvider
      };

      const result = await apiCall(API_ENDPOINTS.SETTLE_BILL, 'POST', orderDetails);

      if (result.success) {
        setSavedItems([]);
        setCart([]);
        setDiscount(0);
        setGlobalDiscount({ type: "fixed", value: 0 });
        setSplitAmounts({ cash: 0, upi: 0, card: 0 });
        setPaymentAmount(0);
        setEnableSplitPayment(false);
        setCustomerInfo({ name: '', phone: '', gstNo: '' });
        setCustomerType('');
        sessionStorage.removeItem("orderID");
        setOrderId(null);
        getallOrderholds();
        setSelectedServiceProvider('');

        if (refundAmount > 0) {
          alert(`Payment successful! Refund amount: ₹${refundAmount.toFixed(2)}`);
        } else {
          alert('Payment successful!');
        }
      } else {
        console.error('Error settling bill:', result.error);
        alert(`Failed to settle bill: ${result.error}`);
      }
    } else {
      alert('Total payment amount does not match the grand total!');
    }
  };




  const handlePrintBill = async () => {
    // Format items for the bill template
    const formattedItems = savedItems.items.map(item => ({
      item_name: item.item_name,
      quantity: item.quantity,
      item_price: parseFloat(item.unit_price),
    }));

    // Calculate totals
    const totals = {
      subtotal: calculateTotal(savedItems.items).total_amount.toFixed(2),
      cgst: parseFloat(savedItems.total_cgst),
      sgst: parseFloat(savedItems.total_sgst),
      itemDiscounts: calculateTotal(savedItems.items).itemDiscounts.toFixed(2), // If you have item-level discounts, calculate here
      totalcgst: calculateTotal(savedItems.items, globalDiscount).total_cgst.toFixed(2),
      totalsgst: calculateTotal(savedItems.items, globalDiscount).total_sgst.toFixed(2),
      globalDiscountAmount: calculateTotal(savedItems.items, globalDiscount).global_discount_amount,
      grandTotal: calculateTotal(savedItems.items, globalDiscount).grand_total.toFixed(2),
      taxableAmount: calculateTotal(savedItems.items, globalDiscount).taxable_amount.toFixed(2),
      totalMRP: calculateTotal(savedItems.items).totalMRP.toFixed(2),

    };



    var customerInfos = savedItems.customer
      ? {
        name: savedItems.customer.name || '',
        phone: savedItems.customer.phone || '',
        gstNo: savedItems.customer.gstNo || '',
      }
      : customerInfo;

    // Payment information
    const paymentInfo = {
      method: savedItems.payment_mode,
      orderNo: savedItems.order_no
    };

    console.log("pay", paymentInfo)
    // Call the printBill function with formatted data
    printBill(
      customerInfos,
      formattedItems,
      totals,
      paymentInfo
    );
  };

  // API Integration Functions
  const apiCall = async (endpoint, method = 'GET', data = null, params = null) => {
    try {
      const config = {
        method,
        url: endpoint,
        ...(data && { data }),
        ...(params && { params })
      };
      const response = await axios(config);
      return { success: true, data: response.data };
    } catch (error) {
      console.error(`API Error [${method} ${endpoint}]:`, error);
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Unknown error'
      };
    }
  };

  // Save items to cart (Create new order)
  const handleSaveBill = async () => {
    const totalValues = calculateTotal(cart);

    const billData = {
      businessEntityId: Number(finalBusinessEntityId) || 1,
      user_id: Number(userId) || 1,
      customer_id: customerInfo?.customer_id || null,
      payment_mode: selectedPaymentMethod || "cash",
      total_amount: Number(totalValues.total_amount) || 0,
      total_discount: Number(totalValues.total_discount) || 0,
      taxable_amount: Number(totalValues.taxable_amount) || 0,
      total_cgst: Number(totalValues.total_cgst) || 0,
      total_sgst: Number(totalValues.total_sgst) || 0,
      grand_total: Number(totalValues.grand_total) || 0,
      ...(sectionbilling === 1 && { section_id: sectionId || null }),
      items: cart.map(item => ({
        item_id: Number(item.item_id),
        quantity: Number(item.quantity) || 1,
        unit_price: Number(item.item_price) || 0,
        discount_type: item.discount_type || "Fixed",
        discount_value: Number(item.discount) || 0,
        discounted_price: Number(item.discount) || 0,
        taxable_amount: Number(item.taxable_amount) || 0,
        cgst: Number(item.cgst) || 0,
        sgst: Number(item.sgst) || 0,
        total_price: Number(item.total_price) || 0
      }))
    };

    const result = await apiCall(API_ENDPOINTS.SAVE_TO_CART, 'POST', billData);

    if (result.success) {
      console.log("Bill saved successfully", result.data);
      sessionStorage.setItem("orderID", result.data.order_id);
      setOrderId(result.data.order_id);
      setCart([]);
      await fetchOrderItems(result.data.order_id);
    } else {
      console.error("Error saving bill:", result.error);
      alert(`Failed to save bill: ${result.error}`);
    }
  };

  const fetchOrderItems = async (id) => {
    if (!id) return;

    sessionStorage.setItem("orderID", id);
    setOrderId(id);
    setLoadingfetch(true);

    const params = sectionbilling === 1 ? { section_id: sectionId } : {};
    const result = await apiCall(`${API_ENDPOINTS.GET_ORDER_ITEMS}/${id}`, 'GET', null, params);

    if (result.success) {
      setSavedItems(result.data);
      if (result.data.customer) {
        setCustomerInfo({
          phone: result.data.customer.phone || "",
          name: result.data.customer.name || "",
          gstNo: result.data.customer.GST_No || ""
        });
        setCustomerType(result.data.customer.phone || "");
      }
    } else {
      console.error("Error fetching order items:", result.error);
      setSavedItems({ items: [] });
    }

    setLoadingfetch(false);
  };

  useEffect(() => {
    if (orderId) {
      fetchOrderItems(orderId);
    }
  }, [orderId]);

  console.log("getall", savedItems)



  // Function to remove a saved bill
  const removeSavedBill = async (billId) => {
    const result = await apiCall(`${API_ENDPOINTS.UPDATE_HOLD_STATUS}/${billId}`, 'PUT');

    if (result.success) {
      console.log("Hold order status updated successfully");
      getallOrderholds(); // Refresh the hold orders list
    } else {
      console.error("Failed to update hold status:", result.error);
    }
  };




  // Remove saved item from order
  const removeSavedItem = async (orderItemId) => {
    if (!savedItems.order_id) {
      console.error("No active order found");
      return;
    }

    setLoadingfetch(true);

    const deleteData = {
      order_item_id: orderItemId,
      order_id: savedItems.order_id
    };

    const result = await apiCall(API_ENDPOINTS.DELETE_ORDER_ITEM, 'DELETE', deleteData);

    if (result.success) {
      console.log("Item deleted successfully");
      // Refresh order items
      await fetchOrderItems(savedItems.order_id);
    } else {
      console.error("Error deleting item:", result.error);
    }

    setLoadingfetch(false);
  };


  // Update saved item quantity
  const updateSavedItemQuantity = async (orderItemId, newQuantity) => {
    if (!savedItems.order_id) {
      console.error("No active order found");
      return;
    }

    if (newQuantity <= 0) {
      await removeSavedItem(orderItemId);
      return;
    }

    setLoadingfetch(true);

    const updateData = {
      order_item_id: orderItemId,
      new_quantity: newQuantity,
      order_id: savedItems.order_id
    };

    const result = await apiCall(API_ENDPOINTS.UPDATE_ITEM_QUANTITY, 'PUT', updateData);

    if (result.success) {
      console.log("Quantity updated successfully");
      // Refresh order items
      await fetchOrderItems(savedItems.order_id);
    } else {
      console.error("Error updating quantity:", result.error);
    }

    setLoadingfetch(false);
  };

  // Update saved item discount
  const updateSavedItemDiscount = async (orderItemId, discountType, discountValue) => {
    if (!savedItems.order_id) {
      console.error("No active order found");
      return;
    }

    setLoadingfetch(true);

    const updateData = {
      order_item_id: orderItemId,
      discount_type: discountType,
      discount_value: discountValue,
      order_id: savedItems.order_id
    };

    const result = await apiCall(API_ENDPOINTS.UPDATE_ITEM_DISCOUNT, 'PUT', updateData);

    if (result.success) {
      console.log("Discount updated successfully");
      // Refresh order items
      await fetchOrderItems(savedItems.order_id);
    } else {
      console.error("Error updating discount:", result.error);
    }

    setLoadingfetch(false);
  };



  const scrollContainerRef = useRef(null);
  const [scrollState, setScrollState] = useState({
    canScrollLeft: false,
    canScrollRight: true,
  });

  const updateScrollState = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      setScrollState({
        canScrollLeft: scrollLeft > 0,
        canScrollRight: scrollLeft + clientWidth < scrollWidth - 10, // Small buffer
      });
    }
  };
  useEffect(() => {
    // Initial check
    updateScrollState();

    // Check after data loads or window resizes
    const checkScrollable = () => {
      setTimeout(updateScrollState, 100);
    };

    window.addEventListener('resize', checkScrollable);

    // Add scroll event listener
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener('scroll', updateScrollState);
      // Force check after render and after a short delay (for content to load)
      checkScrollable();
    }

    return () => {
      window.removeEventListener('resize', checkScrollable);
      if (container) {
        container.removeEventListener('scroll', updateScrollState);
      }
    };
  }, []);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -200, // Adjust the scroll distance as needed
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 200, // Adjust the scroll distance as needed
        behavior: 'smooth',
      });
    }
  };



  // Barcode search functionality
  const handleSearchChange = async (e) => {
    const searchValue = e.target.value;
    setSearchQuery(searchValue);

    if (searchValue) {
      try {
        const url = (sectionbilling === 1)
          ? `${API_ENDPOINTS.GET_ITEM_BY_BARCODE}/${searchValue}/${finalBusinessEntityId}/${sectionId}`
          : `${API_ENDPOINTS.GET_ITEM_BY_BARCODE}/${searchValue}/${finalBusinessEntityId}`;

        const result = await apiCall(url);

        if (result.success && result.data && result.data.length > 0) {
          // Transform the data format
          const transformedItem = {
            item_id: result.data[0].id,
            item_name: result.data[0].name,
            item_price: parseFloat(result.data[0].price),
            item_barcode: result.data[0].barcode || "",
            hsn_code: result.data[0].hsn_code,
            cgst: parseFloat(result.data[0].cgst),
            sgst: parseFloat(result.data[0].sgst)
          };

          // Check if item already exists in cart
          const cartItem = cart.find(item => item.item_id === transformedItem.item_id);
          if (!cartItem) {
            // If item not in cart, add it
            setCart([...cart, {
              ...transformedItem,
              quantity: 1,
              discount: 0
            }]);
          } else {
            // If item already in cart, increment quantity
            updateQuantity(transformedItem.item_id, 1);
          }
          // Clear search after adding to cart
          setSearchQuery('');
        }
      } catch (err) {
        console.error('Error fetching item by barcode:', err);
      }
    }
  };

  const handleSendBill = () => {
    if (!customerInfo.phone) {
      alert("Customer phone number is required to send the bill.");
      return;
    }

    const phoneNumber = customerInfo.phone.replace(/\D/g, ""); // Remove non-numeric characters

    if (phoneNumber.length < 10) {
      alert("Invalid phone number.");
      return;
    }

    const billDetails = savedItems.items.map(item =>
      `${item.quantity}x ${item.item_name} @ ₹${item.unit_price} = ₹${(item.quantity * item.unit_price).toFixed(2)}`
    ).join("\n");

    const total = calculateTotal(savedItems.items, globalDiscount).grand_total.toFixed(2);

    const message = `Hello ${customerInfo.name},\n\nHere is your bill:\n\n${billDetails}\n\nTotal: ₹${total}\n\nThank you for your purchase!`;

    const encodedMessage = encodeURIComponent(message);

    // WhatsApp App Link (Directly opens app if installed)
    const whatsappAppURL = `whatsapp://send?phone=${phoneNumber}&text=${encodedMessage}`;

    // WhatsApp Web Fallback Link
    const whatsappWebURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    // Try opening WhatsApp app
    window.location.href = whatsappAppURL;

    // Check if WhatsApp didn't open (for desktop users without WhatsApp installed)
    setTimeout(() => {
      window.open(whatsappWebURL, "_self"); // Opens in the same tab
    }, 1000);
  };

  const [holdorders, setholdorders] = useState([]);

  const handleRemove = async (billId) => {
    console.log("go")
    await removeSavedBill(billId); // Remove from backend
    getallOrderholds(); // Fetch latest data (optional)
    setSavedItems([]);
    sessionStorage.removeItem('orderID');
  };


  // Fetch all hold orders
  const getallOrderholds = async () => {
    const result = await apiCall(`${API_ENDPOINTS.GET_HOLD_ORDERS}/${finalBusinessEntityId}`);

    if (result.success) {
      setholdorders(result.data.data || []);
    } else {
      console.error("Error fetching hold orders:", result.error);
      setholdorders([]);
    }
  };


  useEffect(
    () => {
      getallOrderholds()
    }, []
  )

  // Hold order functionality
  const handleholdsorder = async () => {
    if (!orderId) {
      alert("No active order to hold");
      return;
    }

    const holdOrderData = {
      order_id: orderId,
      businessEntityId: Number(finalBusinessEntityId),
      customer_name: customerInfo.name || "",
      GST_No: customerInfo.gstNo || "",
      customer_phone: customerInfo.phone || ""
    };

    const result = await apiCall(API_ENDPOINTS.HOLD_ORDER, 'POST', holdOrderData);

    if (result.success) {
      console.log("Order held successfully:", result.data);
      getallOrderholds();
      sessionStorage.removeItem("orderID");
      setOrderId(null);
      setSavedItems({ items: [] });
      setCart([]);
      alert("Bill held successfully!");
    } else {
      console.error("Error holding order:", result.error);
      alert(`Failed to hold order: ${result.error}`);
    }
  };



  const SavedBillsList = () => (
    <div
      className="mt-4 border-top pt-3 overflow-auto"
      style={{ height: "150px" }}
    >
      <h5 className="fw-semibold text-warning mb-3">
        SAVED BILLS:
      </h5>

      <div className="d-flex flex-column gap-2">
        {holdorders.map(bill => (
          <div
            key={bill.id}
            className="d-flex justify-content-between align-items-center bg-light p-2 rounded"
          >
            <div>
              <span className="fw-medium">
                Billing Id : {bill.order_id}
              </span>
            </div>

            <div className="d-flex gap-2">
              <button
                className="btn btn-primary btn-sm"
                onClick={() => fetchOrderItems(bill.order_id)}
              >
                Load
              </button>

              <button
                className="btn btn-danger btn-sm"
                onClick={() => handleRemove(bill.id)}
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );


  // Add items to existing order
  const handleSaveBillUpdate = async () => {
    // Get fresh order ID from sessionStorage
    const currentOrderId = sessionStorage.getItem("orderID");

    if (!currentOrderId || currentOrderId === 'null' || currentOrderId === 'undefined') {
      alert("No active order found");
      return;
    }

    if (cart.length === 0) {
      alert("No items in cart to add");
      return;
    }

    const itemdetails = cart.map(item => ({
      product_id: item.item_id,
      quantity: Number(item.quantity) || 1,
      unit_price: Number(item.item_price) || 0,
      discount_type: item.discount_type || "Fixed",
      discount_value: Number(item.discount) || 0,
      discounted_price: Number(item.discount) || 0,
      taxable_amount: Number(item.taxable_amount) || 0,
      total_price: Number(item.total_price) || 0,
      cgst: Number(item.cgst) || 0,
      sgst: Number(item.sgst) || 0,
    }));

    const orderData = {
      order_id: Number(currentOrderId),
      businessEntityId: finalBusinessEntityId,
      items: itemdetails
    };

    console.log("Adding items to order:", orderData);

    const result = await apiCall(API_ENDPOINTS.ADD_ORDER_ITEM, 'POST', orderData);

    if (result.success) {
      console.log("Items added successfully:", result.data);
      await fetchOrderItems(currentOrderId);
      setCart([]);
      // Clear invoice list and reset states like settle bill
      handleclose();
    } else {
      console.error("Error adding items:", result.error);
      alert(`Failed to add items: ${result.error}`);
    }
  };


  const handleclose = () => {
    sessionStorage.removeItem('orderID');
    setOrderId(null);
    setSavedItems({ items: [] });
    setCart([]);
    setCustomerInfo({ name: '', phone: '', gstNo: '' });
    setCustomerType('');
  };

  const handleAllitem = async () => {
    setLoading(prev => ({ ...prev, items: true }));
    setSelectedCategory(null); // Set "All" as selected
    try {
      const url = (sectionbilling === 1)
        ? `retail/getAllitems/${finalBusinessEntityId}/${sectionId}`
        : `retail/getAllitems/${finalBusinessEntityId}`;
      const response = await axios.get(url);

      console.log("Fetched all items:", response.data);

      setMenuItems(response.data);
    } catch (error) {
      console.error("Error fetching all items:", error);
      setError(prev => ({ ...prev, items: "Failed to fetch all items" }));
    } finally {
      setLoading(prev => ({ ...prev, items: false }));
    }
  };


  // Check customer type
  const checkCustomerType = async () => {
    if (!customerInfo.phone) {
      console.log("Please enter a phone number");
      return;
    }

    if (customerInfo.phone.length === 10) {
      const result = await apiCall(`${API_ENDPOINTS.CHECK_CUSTOMER_TYPE}?phone=${customerInfo.phone}`);

      if (result.success) {
        setCustomerType(result.data.customer_type);
      } else {
        console.error("Error fetching customer data:", result.error);
      }
    }
  };

  useEffect(() => {
    checkCustomerType();
  }, [customerInfo.phone]);

  return (
    <div className="d-flex vh-100">
      <Sidebar />

      <div className="d-flex flex-column w-100">
        <Navbar />

        <div
          className="d-flex gap-3 p-3"
          style={{ height: "calc(100vh - 80px)" }}
        >
          {/* LEFT PANEL */}
          <div className="bg-white flex-grow-1 p-3 rounded shadow-sm col-6">

            {/* Sections */}
            <div className="mb-3 border-bottom">
              {loading.sections ? (
                <div className="text-center">Loading sections...</div>
              ) : error.sections ? (
                <div className="text-danger">{error.sections}</div>
              ) : (
                <div className="d-flex justify-content-between">
                  {sections.map(section => (
                    <div
                      key={section.id}
                      className="flex-fill text-center position-relative cursor-pointer"
                      onClick={() => {
                        setSelectedSection(section);
                        setSectionId(section.id);
                      }}
                    >
                      <span
                        className={`pb-2 d-inline-block ${selectedSection?.id === section.id
                          ? "text-warning fw-semibold"
                          : "text-secondary"
                          }`}
                      >
                        {section.name}
                      </span>

                      {selectedSection?.id === section.id && (
                        <div
                          className="position-absolute start-50 translate-middle-x bg-warning rounded"
                          style={{ bottom: "-2px", width: "80px", height: "4px" }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Categories Scroll */}
            <div className="position-relative d-flex align-items-center mb-3">
              <button
                onClick={scrollLeft}
                disabled={!scrollState.canScrollLeft}
                className="btn btn-light position-absolute start-0 z-3"
              >
                <span style={{ fontSize: "32px" }}>&lsaquo;</span>
              </button>

              <div
                ref={scrollContainerRef}
                className="d-flex overflow-auto w-100 px-5 py-2"
                style={{ whiteSpace: "nowrap" }}
              >
                {loading.categories ? (
                  <div>Loading categories...</div>
                ) : error.categories ? (
                  <div className="text-danger">{error.categories}</div>
                ) : (
                  <>
                    <button
                      className={`btn me-2 ${selectedCategory === null
                        ? "btn-warning text-white"
                        : "btn-light"
                        }`}
                      onClick={handleAllitem}
                    >
                      All
                    </button>

                    {categories.map(category => (
                      <button
                        key={category.category_id}
                        className={`btn me-2 ${selectedCategory && selectedCategory.category_id === category.category_id
                          ? "btn-warning text-white"
                          : "btn-light"
                          }`}
                        onClick={() => {
                          fetchItems(category.category_id);
                          setSelectedCategory(category);
                        }}
                      >
                        {category.category_name}
                      </button>
                    ))}
                  </>
                )}
              </div>

              <button
                onClick={scrollRight}
                disabled={!scrollState.canScrollRight}
                className="btn btn-light position-absolute end-0 z-3"
              >
                <span style={{ fontSize: "32px" }}>&rsaquo;</span>
              </button>
            </div>

            {/* Search */}
            <div className="input-group mb-3">
              <span className="input-group-text bg-white border-end-0">
                <Search size={18} />
              </span>
              <input
                type="text"
                className="form-control border-start-0"
                placeholder="Search by barcode or name"
                value={searchQuery}
                onChange={handleSearchChange}
                autoFocus
              />
            </div>

            {/* Menu Items */}
            <div
              className="d-flex flex-wrap gap-3 overflow-auto"
              style={{ height: holdorders.length ? "240px" : "400px" }}
            >
              {loading.items ? (
                <div className="text-center w-100">Loading items...</div>
              ) : error.items ? (
                <div className="text-danger w-100">{error.items}</div>
              ) : (
                menuItems
                  .filter(item =>
                    item.item_name
                      .toLowerCase()
                      .includes(searchQuery.toLowerCase()) ||
                    item.item_barcode?.includes(searchQuery)
                  )
                  .map(item => {
                    const cartItem = cart.find(i => i.item_id === item.item_id);
                    return (
                      <div key={item.item_id} style={{ flex: "0 0 200px", width: "200px" }}>
                        <div
                          className="p-3 rounded"
                          style={{ boxShadow: "1px 7px 16px #ccc" }}
                        >
                          <div className="text-success fw-medium">
                            {item.item_name.length > 16
                              ? `${item.item_name.slice(0, 14)}...`
                              : item.item_name}
                          </div>

                          {item.item_barcode && (
                            <small className="text-muted">
                              Barcode: {item.item_barcode}
                            </small>
                          )}

                          <div className="text-warning mt-1">
                            ₹{item.item_price}
                          </div>

                          {!cartItem ? (
                            <button
                              className="btn btn-link p-0 mt-2"
                              onClick={() => addToCart(item)}
                            >
                              <ShoppingCart size={16} /> Add Item
                            </button>
                          ) : (
                            <div className="d-flex align-items-center gap-2 mt-2">
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() =>
                                  updateQuantity(item.item_id, -1)
                                }
                              >
                                -
                              </button>
                              <span>{cartItem.quantity}</span>
                              <button
                                className="btn btn-success btn-sm"
                                onClick={() =>
                                  updateQuantity(item.item_id, 1)
                                }
                              >
                                +
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })
              )}
            </div>

            {(holdorders?.length > 0) && (
              <SavedBillsList />
            )}
          </div>

          {/* RIGHT PANEL  */}
          <div className="bg-white flex-fill p-4 rounded shadow-sm overflow-auto col-6">
            <div>
              {/* Header */}
              <div className="d-flex justify-content-between align-items-start">
                <h2 className="mb-4" style={{ fontSize: "27px" }}>
                  <span className="fw-semibold">Items</span>
                  {savedItems.order_id && (
                    <span className="text-secondary fs-5 ms-2">
                      (Order id:{savedItems.order_id})
                    </span>
                  )}
                </h2>
                <RiEraserFill
                  onClick={handleclose}
                  style={{ width: "20px", height: "20px", marginTop: "8px", cursor: "pointer" }}
                />
              </div>

              {/* Table Header */}
              <div className="row py-2 border-bottom fw-semibold bg-danger text-white small">
                <div className="col-3">HSN NO.</div>
                <div className="col-3">Item Name</div>
                <div className="col-3">Price</div>
                <div className="col-1">Qty</div>
                <div className="col-2">Discount</div>
              </div>

              {/* Cart Items */}
              {(cart.length > 0 || Array.isArray(savedItems.items)) ? (
                <div className="mb-4">
                  {cart.map((item, index) => (
                    <CartItemRow key={`cart-${index}`} item={item} saved={false} />
                  ))}
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center mt-5">
                  No Items Found
                </div>
              )}

              {/* Saved Items */}
              {Array.isArray(savedItems.items) &&
                savedItems.items.map((item, index) => (
                  <CartItemRow
                    key={`saved-${index}`}
                    item={item}
                    saved={true}
                    onRemove={(itemId) => removeSavedItem(itemId)}
                    onQuantityChange={(orderItemId, newQuantity) =>
                      updateSavedItemQuantity(orderItemId, newQuantity)
                    }
                    onDiscountChange={(orderItemId, discountType, discountValue) =>
                      updateSavedItemDiscount(orderItemId, discountType, discountValue)
                    }
                  />
                ))}

              {/* Save Button */}
              {cart.length > 0 && (
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-success px-4"
                    onClick={() => {
                      const currentOrderId = sessionStorage.getItem("orderID");
                      if (currentOrderId && currentOrderId !== 'null' && currentOrderId !== 'undefined') {
                        handleSaveBillUpdate();
                      } else {
                        handleSaveBill();
                      }
                    }}
                  >
                    Save
                  </button>
                </div>
              )}
            </div>

            {/* Summary Section */}
            {Array.isArray(savedItems.items) && savedItems.items.length > 0 && (
              <div className="bg-light p-4 rounded mt-4">
                <div className="d-flex justify-content-end">
                  <div className="bg-dark text-white p-4 rounded w-50">
                    <div className="d-flex justify-content-between">
                      <span>Sub Total:</span>
                      <span>₹{(calculateTotal(savedItems.items).totalMRP || 0).toFixed(2)}</span>
                    </div>

                    {(calculateTotal(savedItems.items).itemDiscounts || 0) > 0 && (
                      <div className="d-flex justify-content-between text-warning">
                        <span>Item Discounts:</span>
                        <span>-₹{(calculateTotal(savedItems.items).itemDiscounts || 0).toFixed(2)}</span>
                      </div>
                    )}

                    {(calculateTotal(savedItems.items, globalDiscount).global_discount_amount || 0) > 0 && (
                      <div className="d-flex justify-content-between text-warning">
                        <span>Bill Discount:</span>
                        <span>
                          -₹{(calculateTotal(savedItems.items, globalDiscount).global_discount_amount || 0).toFixed(2)}
                        </span>
                      </div>
                    )}

                    <div className="d-flex justify-content-between fw-bold">
                      <span>Grand Total:</span>
                      <span>
                        ₹{(calculateTotal(savedItems.items, globalDiscount).grand_total || 0).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Customer Information */}
                <div className="mt-4">
                  <div className="d-flex align-items-center gap-2">
                    <h5 className="fw-semibold text-warning mb-0">CUSTOMER INFORMATION:</h5>
                    {customerType && <span>({customerType})</span>}
                  </div>

                  <div className="row mt-2">
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Phone No."
                        value={customerInfo.phone}
                        onChange={(e) =>
                          setCustomerInfo({ ...customerInfo, phone: e.target.value })
                        }
                      />
                    </div>

                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        value={customerInfo.name}
                        onChange={(e) =>
                          setCustomerInfo({ ...customerInfo, name: e.target.value })
                        }
                      />
                    </div>
                  </div>

                  <div className="mt-2 col-md-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="GST No. (Optional)"
                      value={customerInfo.gstNo}
                      onChange={(e) =>
                        setCustomerInfo({ ...customerInfo, gstNo: e.target.value })
                      }
                    />
                  </div>
                </div>

                <div className="mt-4">
                  <div className="d-flex flex-column gap-2">
                    <h5 className="fw-semibold text-warning mb-0">Service Provider</h5>

                    <Select
                      value={selectedServiceProvider}
                      onChange={(e) => setSelectedServiceProvider(e.target.value)}
                      displayEmpty
                      className="flex-fill"
                      size="small"
                    >
                      <MenuItem value="">
                        <em>Select Provider</em>
                      </MenuItem>
                      {serviceProviders?.map((provider) => (
                        <MenuItem key={provider.user_id} value={provider.user_id}>
                          {provider.first_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </div>

                {/* Bill Discount */}
                <div className="mt-4">
                  <h6 className="fw-semibold text-warning">MORE DETAILS:</h6>

                  <div className="mt-3">
                    <h6>Bill Discount:</h6>
                    <div className="row g-2">
                      <div className="col-md-4">
                        <select
                          className="form-select"
                          value={globalDiscount.type}
                          onChange={(e) =>
                            setGlobalDiscount((prev) => ({
                              ...prev,
                              type: e.target.value,
                            }))
                          }
                        >
                          <option value="fixed">Fixed Amount (₹)</option>
                          <option value="percentage">Percentage (%)</option>
                        </select>
                      </div>

                      <div className="col-md-8">
                        <input
                          type="text"
                          className="form-control"
                          value={Number(globalDiscount.value)}
                          onChange={(e) => {
                            if (isNaN(e.target.value)) {
                              return
                            }
                            setGlobalDiscount((prev) => ({
                              ...prev,
                              value: Number(e.target.value) || 0,
                            }))
                          }}
                          placeholder="Enter discount"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mt-4">
                    <label className="d-flex align-items-center gap-2">
                      <input
                        type="checkbox"
                        checked={enableSplitPayment}
                        onChange={(e) => setEnableSplitPayment(e.target.checked)}
                      />
                      Enable Split Payment
                    </label>
                    {enableSplitPayment ? (
                      <div className="mt-2">
                        {['cash', 'upi', 'card'].map((method) => (
                          <div key={method} className="d-flex align-items-center gap-2">
                            <span className='w-16'>{method.toUpperCase()}</span>
                            <input
                              type="number"
                              className="form-control"
                              value={splitAmounts[method] || ''}
                              onChange={(e) =>
                                setSplitAmounts({
                                  ...splitAmounts,
                                  [method]: e.target.value === '' ? '' : Number(e.target.value),
                                })
                              }
                            />
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="mt-2">
                        <select
                          className="form-select"
                          value={selectedPaymentMethod}
                          onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                        >
                          <option value="">Select Payment Method</option>
                          <option value="cash">Cash</option>
                          <option value="upi">UPI</option>
                          <option value="card">Card</option>
                        </select>
                        <input
                          type='text'
                          placeholder="Enter Amount"
                          className="form-control mt-2"
                          value={Number(paymentAmount)}
                          onChange={(e) => {
                            if (isNaN(e.target.value)) {
                              return
                            }
                            setPaymentAmount(Number(e.target.value));
                          }}
                        />
                      </div>
                    )}
                  </div>

                  {/* Action Buttons */}
                  <div className="d-flex gap-2 mt-4">
                    <button className="btn btn-success flex-fill" onClick={handlePrintBill}>
                      Print Bill
                    </button>
                    <button className="btn btn-success flex-fill" onClick={handleholdsorder}>
                      Save Bill
                    </button>
                    <button className="btn btn-success flex-fill" onClick={handleSettleBill}>
                      Settle Bill
                    </button>
                    <button className="btn btn-success flex-fill" onClick={handleSendBill}>
                      Send Bill
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );

};

export default RetailDashboard
